<template>
  <div v-if="shouldShowBanner">
    <banner
      color-scheme="info"
      :banner-message="bannerMessage"
      has-action-button
      :action-button-label="$t('WHATS_NEW.BANNER.DISCOVER')"
      action-button-icon="sparkle"
      @click="openModal"
    />
    <whats-new-modal
      :show="showModal"
      :releases="unseenReleases"
      @close="closeModal"
    />
  </div>
</template>

<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import WhatsNewModal from './WhatsNewModal.vue';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import {
  getLatestVersion,
  getUnseenReleases,
  hasUnseenReleases,
} from 'dashboard/helper/whatsNewData';

export default {
  name: 'WhatsNewBanner',
  components: {
    Banner,
    WhatsNewModal,
  },
  data() {
    return {
      showModal: false,
      userDismissed: false,
      lastSeenVersion: null,
    };
  },
  computed: {
    latestVersion() {
      return getLatestVersion();
    },
    hasUnseen() {
      return hasUnseenReleases(this.lastSeenVersion);
    },
    unseenReleases() {
      return getUnseenReleases(this.lastSeenVersion);
    },
    shouldShowBanner() {
      return !this.userDismissed && this.hasUnseen;
    },
    bannerMessage() {
      const count = this.unseenReleases.length;
      if (count === 1) {
        const release = this.unseenReleases[0];
        const title = this.$t(release?.titleKey) || release?.title;
        return this.$t('WHATS_NEW.BANNER.SINGLE_UPDATE', { title });
      }
      return this.$t('WHATS_NEW.BANNER.MULTIPLE_UPDATES', { count });
    },
  },
  mounted() {
    this.lastSeenVersion = LocalStorage.get(LOCAL_STORAGE_KEYS.WHATS_NEW_SEEN);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.markAsSeen();
    },
    dismissBanner() {
      this.markAsSeen();
      this.userDismissed = true;
    },
    markAsSeen() {
      if (this.latestVersion) {
        LocalStorage.set(LOCAL_STORAGE_KEYS.WHATS_NEW_SEEN, this.latestVersion);
        this.lastSeenVersion = this.latestVersion;
      }
    },
  },
};
</script>
